import React, { useEffect, useState } from 'react'

import LiveLoading from 'live/components/ui/Loading'
import i18n from 'live/services/i18n'

import { EntityEditorModal } from '../../../../../generic'
import { IBarrier, IBarrierTypeIcon, IMethod } from '../../../../../types'
import { IEditorBarrier, IUpdateMethodsOptions } from '../../BarrierEditor'
import { AssignModal, EditModal } from './components'
import { AbsoluteLoadingContainer } from './styles'

interface IProps {
    handleClose: () => void
    handleChange: () => void
    handleMethodChange: () => void
    handleGetRecursiveSearch: (k: IEditorBarrier) => IEditorBarrier[]
    isOpen: boolean
    item?: IBarrier[]
    borderColor: string
    title: string
    updateModeMethods: IUpdateMethodsOptions[]
    defaultMethod: IMethod
    barrierTypeIconMap: Map<number, IBarrierTypeIcon>
}

export const BarrierEditModal: React.FC<IProps> = ({
    handleClose,
    isOpen,
    item,
    handleGetRecursiveSearch,
    handleChange,
    borderColor,
    title,
    updateModeMethods,
    handleMethodChange,
    defaultMethod,
    barrierTypeIconMap
}) => {
    const [loading, setLoading] = useState(false)
    const [isEditModal, setIsEditModal] = useState(false)

    useEffect(() => {
        if (!isOpen) {
            setIsEditModal(false)
        }
    }, [isOpen])

    return (
        item?.length > 0 && (
            <EntityEditorModal
                handleClose={handleClose}
                isOpen={isOpen}
                borderColor={borderColor}
                headerTitle={i18n(title)}
                headerSubtitle={item[0]?.id ? '#' + item[0].id : ''}
            >
                {item[0]?.root || isEditModal ? (
                    <EditModal
                        handleChange={handleChange}
                        setLoading={setLoading}
                        item={item}
                        handleGetRecursiveSearch={handleGetRecursiveSearch}
                        updateModeMethods={updateModeMethods}
                        handleMethodChange={handleMethodChange}
                        defaultMethod={defaultMethod}
                        barrierTypeIconMap={barrierTypeIconMap}
                    />
                ) : (
                    <AssignModal
                        handleGetRecursiveSearch={handleGetRecursiveSearch}
                        handleChange={handleChange}
                        item={item as IEditorBarrier[]}
                        setLoading={setLoading}
                        updateModeMethods={updateModeMethods}
                        // selectedMethod={selectedMethod}
                        setIsEditModal={setIsEditModal}
                    />
                )}

                {loading && (
                    <AbsoluteLoadingContainer>
                        <div>
                            <LiveLoading show />
                        </div>
                    </AbsoluteLoadingContainer>
                )}
            </EntityEditorModal>
        )
    )
}
